import axiosApiInstance from "@services/custom-axios-instance"
import { generateUrl } from "@services/generateUrl/generateUrl"
//***** Interfaces *****
import {OfficeSaveI, PractitionerOfficeI, SchedulerI}  from "@interfaces/practititoner/offices"
import { SchedulesOfficeServiceIdsI } from "@customHooks/practitioner/use-practitioner-schedules-byid"
import drpServicesServiceApiInstance from "@services/clients/drproxservices"


export async function getPractitionerOffices(practitionerId: number | string, organizationId: number, isOwner: boolean) {
    const practitionerEndpoint = `${generateUrl()}/drproxservices/api/v1/practitioner/office?practitionerId=${practitionerId}`
    const organizationEndpoint = `${generateUrl()}/drproxservices/api/v1/practitioner/office/organization/${organizationId}`
    const endpoint = isOwner ? practitionerEndpoint : organizationEndpoint
    console.debug("Get Offices:", endpoint, practitionerId, organizationId)
    const response = await axiosApiInstance.get<PractitionerOfficeI[]>(endpoint)
    return response.data
}
export async function getPractitionerOfficesByUsername(practitionerUsername: string, organizationId: number, isOwner: boolean) {
    const practitionerEndpoint = `${generateUrl()}/drproxservices/api/v1/practitioner/office/user/${practitionerUsername}`
    const organizationEndpoint = `${generateUrl()}/drproxservices/api/v1/practitioner/office/organization/${organizationId}`
    const endpoint = isOwner ? practitionerEndpoint : organizationEndpoint
    const response = await axiosApiInstance.get<PractitionerOfficeI[]>(endpoint)
    return response.data
}

export async function getOffice(id: string, username: string) 
{
    const url = `${generateUrl()}/drproxservices/api/v1/practitioner/office/${id}?practitionerId=${username}`
    console.debug("Get Office URL:", url)
    const response = await axiosApiInstance.get(url)
    return response.data
}

export async function getSchedulesByOfficeServiceIds(officeServiceIds: SchedulesOfficeServiceIdsI) {
    const url = `/api/v1/practitioner/office/${officeServiceIds.officeId}/service/${officeServiceIds.servicceId}`
    const response = await drpServicesServiceApiInstance.get(url)
    return response.data as SchedulerI
}

export async function saveOffice(office: OfficeSaveI) {
    const url = `${generateUrl()}/drproxservices/api/v1/practitioner/office`
    const response = await axiosApiInstance.post(url, office)
    return response.data
}

export async function updateOffice(office: OfficeSaveI) {
    const url = `${generateUrl()}/drproxservices/api/v1/practitioner/office/${office.id}`
    const response = await axiosApiInstance.put(url, office)
    return response.data
}

export async function deleteOffice(officeId: string) {
    const url = `${generateUrl()}/drproxservices/api/v1/practitioner/office/${officeId}`
    const response = await axiosApiInstance.delete(url)
    return response.data
}